var map = {
	"./cashapp.png": 1264,
	"./cody.png": 9978,
	"./facebook.png": 1708,
	"./logo.png": 5420,
	"./paypal.png": 78,
	"./paypalqrcode.png": 3454,
	"./tiktok.png": 640,
	"./twitter.png": 8614,
	"./youtube.png": 76
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2254;